import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import PromotionBox, {
  CtaDesigns,
} from 'src/components/HomePromotionsStack/PromotionBox/PromotionBox'
import SvgCardLoD from 'src/components/Svgs/SvgCardLoD'
import { CookieNames, CookieValuePaths } from 'src/cookies'
import { ImageNames } from 'src/enums'
import { useCookieState } from 'src/hooks'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import { useTranslate } from 'src/localization/Trns'
import { requestVirtualCardUrl } from 'src/navigation/urls'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'
import { css } from 'styled-components'

interface RequestVirtualCardPromotionBoxProps {
  className?: string
  ctaProps: {
    ctaDesign: CtaDesigns
    ctaContent?: React.ReactElement
  }
  isHighlighted?: boolean
}

const RequestVirtualCardPromotionBox: React.FC<
  RequestVirtualCardPromotionBoxProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )
  const virtualCardImageSrc = useColorOrGrayscaleImage(ImageNames.VirtualCard)

  const { analytics } = useAnalyticsContext()

  const {
    cookieValue: showRequestCardTooltip,
    updateCookieValue: setShowRequestCardTooltip,
  } = useCookieState(
    CookieNames.Onboarding,
    CookieValuePaths.shouldShowRequestCardPromo,
    true,
  )

  return (
    <PromotionBox
      className={props.className}
      imageSrc={virtualCardImageSrc}
      id="needAVirtCardPromoBox"
      title={translate('Need a virtual card?')}
      subtitle={translate(
        'You can request a virtual card from someone with an account or budget',
      )}
      ctaProps={{
        ctaDesign: props.ctaProps.ctaDesign,
        ctaContent: props.ctaProps?.ctaContent || (
          <div
            css={css`
              display: flex;
              align-items: center;
            `}
          >
            {props.ctaProps.ctaDesign === CtaDesigns.button && (
              <SvgCardLoD
                css={css`
                  transform: scale(calc(18 / 24));
                  transform-origin: left;
                  ${getBreakpointDown(breakpointSizes.XSM)(css`
                    display: none;
                  `)}
                `}
              />
            )}
            {translate('Request Virtual Card')}
          </div>
        ),
        ctaTo: requestVirtualCardUrl(),
        ctaAriaLabelSource: 'Request Virtual Card',
        onCtaClick: (): void => {
          analytics?.track('request vcn promo - request virtual card', {
            screen: calculatedBackgroundLocation.pathname,
          })
        },
      }}
      tooltipProps={{
        showTooltip: showRequestCardTooltip && props.isHighlighted === true,
        setShowTooltip: setShowRequestCardTooltip,
        tooltipText: translate(
          'Simply request a virtual card! Once approved, you can immediately use it for purchases.',
        ),
        tooltipTitle: translate('Just one step!'),
      }}
    />
  )
}

export default RequestVirtualCardPromotionBox
